export const v4 = (): string => {
  return crypto.randomUUID();
};
